import { render, staticRenderFns } from "./itemGalleryImage.vue?vue&type=template&id=97f761a0&"
import script from "./itemGalleryImage.vue?vue&type=script&lang=js&"
export * from "./itemGalleryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports